import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: any) => ({
    datePickerInput: {
        position: 'relative',

        '& span': {
            position: 'absolute',
            top: '10px',
            right: '0px',
            pointerEvents: 'none',
        },
    },
    filterByDateText: {
        [theme.breakpoints.only('xs')]: {
            display: 'none',
        },
    },
    rangeDatePickerWrapper: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        padding: '10px 0px 10px 0px',
        justifyContent: 'center',
        [theme.breakpoints.up('lg')]: {
            justifyContent: 'flex-end',
        },

        [theme.breakpoints.down('md')]: {
            marginRight: theme.spacing(4),
            marginTop: '10px',
        },

        [theme.breakpoints.down('sm')]: {
            display: 'grid',
            rowGap: 10,
            justifyItems: 'center',
            flexDirection: 'column',
            marginRight: 0,
            padding: '8px 0px 10px 0px',
        },
    },
    rangeDatePicker: {
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.down('md')]: {
            flexDirection: 'row',
        },
    },
    datePickerTextInput: {
        backgroundColor: 'white',
        height: '36px',
        borderRadius: '5px',
        border: 'none',
        width: '137px',
        fontSize: '14px',
        color: '#a8aaae',
        paddingLeft: '12px',
        cursor: 'pointer',
        '&:focus': {
            outline: 'none',
        },
    },
    lastUpdatedTextWrapper: {
        [theme.breakpoints.down('lg')]: {
            width: '100%',
            backgroundColor: 'hsl(197deg 62% 51%)',
        },
        [theme.breakpoints.down('md')]: {
            width: '100%',
            backgroundColor: 'hsl(197deg 62% 51%)',
        },
    },
    lastUpdatedText: {
        color: 'white',
        margin: '0 70px',
        padding: '8px 20px',
        border: '1px solid white',
        borderRadius: '5px',
        whiteSpace: 'nowrap',

        [theme.breakpoints.down('md')]: {
            border: 'none',
            padding: '5px 0',
            display: 'flex',
            fontSize: '14px',
            justifyContent: 'center',
        },
    },

    menuButton: {
        [theme.breakpoints.up('lg')]: {
            display: 'none',
        },
    },

    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
    },
    closeMenuButton: {
        marginRight: 'auto',
        marginLeft: 0,

        [theme.breakpoints.down('md')]: {
            marginRight: 0,
        },
    },
    drawHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        paddingLeft: '18px',
    },
}));
